'use client';

import { useFlags } from 'launchdarkly-react-client-sdk';

import { useDevLdFlagOverridesStore } from './dev-overrides-store';

const isDev = process.env.NODE_ENV === 'development';

export function useFeatureFlags<TFlag extends string = string>(): Record<TFlag, boolean> {
  const flags = useFlags();
  const overrides = useDevLdFlagOverridesStore((state) => (isDev ? state.overrides : null));

  if (!isDev || !overrides || Object.keys(overrides).length === 0) {
    return flags as Record<TFlag, boolean>;
  }

  return { ...flags, ...overrides } as Record<TFlag, boolean>;
}
